import { CardModifierType } from 'Prototype/Level/Card/CardModifierType';
import Component from '../Component';

export default class CardModifierComponent extends Component {
    public properties: any = undefined;
    public type: CardModifierType = undefined;
    public cardID: string = undefined;
}
